export default __webpack_public_path__ + "static/media/LoyaltyGroup.9a3d0a08.xlsx";